import { EventOption, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';

export function selectByOddsKeyMarginRule<T>(
    items: T[],
    getSpread: (item: T) => number | undefined,
    getOddsKey: (item: T) => number | undefined,
): T | undefined {
    const ODDS_KEY_MARGIN_THRESHOLD = 0.4;
    const candidates: { item: T; spread: number; oddsKey: number }[] = [];

    for (const item of items) {
        const spread = getSpread(item);
        const oddsKey = getOddsKey(item);
        if (spread !== undefined && spread <= ODDS_KEY_MARGIN_THRESHOLD && oddsKey !== undefined) {
            candidates.push({ item, spread, oddsKey });
        }
    }

    const top3 = candidates.sort((a, b) => a.spread - b.spread).slice(0, 3);

    if (top3.length === 0) {
        return undefined;
    }

    const minOddsKey = Math.min(...top3.map((c) => c.oddsKey));

    const bestCandidates = top3.filter((c) => c.oddsKey < minOddsKey + 1);

    return bestCandidates.length > 0 ? bestCandidates.reduce((best, current) => (current.spread < best.spread ? current : best)).item : top3[0].item;
}

export function selectLowestSpreadItem<T>(items: T[], getOrder: (item: T) => number, filter?: (item: T) => boolean): T | undefined {
    const filtered = filter ? items.filter(filter) : items;
    if (filtered.length === 0) {
        return undefined;
    }

    return filtered.reduce((lowest, current) => (getOrder(current) < getOrder(lowest) ? current : lowest));
}

export function extractSpreadValue(item: EventOption | EventOptionGroup): number {
    return typeof item.optionSpread === 'number' ? item.optionSpread : Number.MAX_VALUE;
}
